export const environment = {
  production: true,
  embeddedMode: true,
  fullScreenMode: true,
  browserTabTitle: "Titan Serviceai-Multitenant AI Agent",

  apiURL: "/",
  /** Optional local dev fallback when hostname is not in tenants.hostname (e.g. localhost). */
  defaultTenantCode: "" as string | undefined,
  rSocketUrl: "/ws",
  signalRUrl: "/hubs/chat",

  awsApiKey: "8otJYPiMpj9VbeksTpA8L8GFXeglKzEY97wwI9PF",
  humanAgentSessionClosedMessage: "SESSION IS CLOSED FROM HUMAN AGENT",
  componentType: "CHAT_BOT",

  humanAgentFeature: true,
  useSignalR: false,
  
  ngxToasterTimeout: 5000,
  streamResponseTypingSpeed: 8,
  humanAgentDisconnectionTime:5000,
  intervalForWebSocketReconnection:10000,
};